import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SessionService, AuthModule } from '@auth/auth';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { FunctionalRoleGuard } from './core/guards/functional/functional-role.guard';
import { TimerService } from './core/services/timer.service';
import { LoginGuard } from './core/guards/route/login.guard';
import { SessionStorage } from './core/services';
import { v4 as uuidv4 } from 'uuid';
import { CdsModalService } from '@cds/angular';
import { APP_ENVIRONMENT, AppEnvironment } from './app.environment';
import { ShellService } from './core/services/shell.service';
import { ConfigService } from './features/reporting/services/config/config.service';

export const ENVIRONMENT = 'ENVIRONMENT';

function initializeAppFactory(sessionStorage: SessionStorage): () => void {
  return () => {
    sessionStorage.set('Session-Id', uuidv4());
 }
}

@NgModule({ declarations: [
        AppComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        AuthModule.forRoot()], providers: [
        SessionService,
        SessionStorage,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        LoginGuard,
        FunctionalRoleGuard,
        TimerService,
        ConfigService,
        {
            provide: ENVIRONMENT,
            deps: [APP_ENVIRONMENT],
            useFactory: (appEnvironment: AppEnvironment) => appEnvironment
        },
        {
            provide: APP_INITIALIZER,
            useFactory: initializeAppFactory,
            deps: [SessionStorage],
            multi: true
        },
        CdsModalService,
        {
            provide: 'ShellService',
            useClass: ShellService
        },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule {

}
